import { Language } from "../types/types";

interface LinkNames {
    about: string;
    company: string;
    team: string;
    documents: string;
    services:string;
    courses: string;
    apply: string;
    qualification: string;
    companies: string;
    unemployed: string;
    stars: string;
    howToChoose: string;
    short: string;
    certification: string;
    learner: string;
    faq: string;
    contacts: string;
    sitemap: string;
    tig: string;
    mag: string;
    mig: string;
    mma: string;

}

const linkNames: Record<Language, LinkNames> = {
  lv: {
    about: "par-mums",
    company: "uznemums",
    team: "komanda",
    documents: "dokumenti",
    services:"pakalpojumi",
    courses: "kursi",
    apply: "pieteikties",
    qualification: "kvalifikacija",
    companies: "uznemumiem",
    unemployed: "bezdarbniekiem",
    stars: "stars",
    howToChoose: "ka-izveleties",
    short: "40-stundu-kursi",
    certification: "sertifikacija",
    learner: "izglitojamajiem",
    faq: "buj",
    contacts: "kontakti",
    sitemap: "lapas-karte",
    tig: "tig",
    mag: "mag",
    mig: "mig",
    mma: "mma",
  },
  en: {
    about: "about",
    company: "company",
    team: "team",
    documents: "documents",
    services:"services",
    courses: "courses",
    apply: "apply",
    qualification: "qualification",
    companies: "companies",
    unemployed: "unemployed",
    stars: "stars",
    howToChoose: "how-to-choose",
    short: "40-hour-courses",
    certification: "certification",
    learner: "learner",
    faq: "faq",
    contacts: "contacts",
    sitemap: "sitemap",
    tig: "tig",
    mag: "mag",
    mig: "mig",
    mma: "mma",
    
  },
  ru: {
    about: "o-nas",
    company: "kompaniya",
    team: "komanda",
    documents: "dokumenty",
    services:"uslugi",
    courses: "kursy",
    apply: "zapisatsya",
    qualification: "kvalifikaciya",
    companies: "kompanii",
    unemployed: "bezrabotnye",
    stars: "stars",
    howToChoose: "kak-vybrat",
    short: "40-chasovye-kursy",
    certification: "sertifikaciya",
    learner: "dlya-uchashchikhsya",
    faq: "faq",
    contacts: "kontakty",
    sitemap: "karta",
    tig: "tig",
    mag: "mag",
    mig: "mig",
    mma: "mma",
  },
};

export default linkNames;
